import React from "react";
import { Svg } from "../componet/Orientation/style";

function Icon() {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="39"
      fill="none"
      viewBox="0 0 36 39"
      notification="true"
    >
      <g fill="#A71B38" opacity="0.25">
        <path
          d="M34.374 9.594a.756.756 0 00-.8.8v15.987a.757.757 0 01-.8.8h-2.955a.8.8 0 000 1.6h2.955a2.356 2.356 0 002.4-2.4V10.394a.754.754 0 00-.8-.8zM4.793 4.001a.8.8 0 11-1.6 0 .8.8 0 011.6 0zM7.193 4.001a.8.8 0 11-1.6 0 .8.8 0 011.6 0zM9.594 4.001a.8.8 0 11-1.6 0 .8.8 0 011.6 0zM31.173 3.201H11.995a.756.756 0 00-.8.8.757.757 0 00.8.8h19.178a.757.757 0 00.8-.8.757.757 0 00-.8-.8z"
          opacity="0.25"
        ></path>
        <path
          d="M32.774 0h-30.4A2.357 2.357 0 000 2.401v23.98a2.356 2.356 0 002.375 2.4h2.101a.8.8 0 100-1.6H2.375a.756.756 0 01-.774-.8V2.4a.756.756 0 01.774-.8h30.399a.756.756 0 01.8.8v3.992H3.993a.756.756 0 00-.792.8.747.747 0 00.792.8h30.381a.756.756 0 00.8-.8V2.401a2.355 2.355 0 00-2.4-2.4z"
          opacity="0.25"
        ></path>
      </g>
      <g fill="#A71B38" clipPath="url(#clip0_397_1161)">
        <path
          fillRule="evenodd"
          d="M23.866 19.966c-3.213-1.83-7.375-.772-9.26 2.448l-2.582 4.408-3.587 2.335c-.735.478-.717 1.47.193 2.047l3.456 1.967c-.801 1.634-.183 3.611 1.411 4.518 1.594.907 3.637.446 4.668-1.06l3.14 1.788c.9.512 2.144.346 2.216-.847l.247-4.054 2.581-4.406c1.889-3.225.733-7.314-2.483-9.144zM14.398 36.13a1.664 1.664 0 01-.734-2.062l2.92 1.662a1.73 1.73 0 01-2.186.4zm10.386-7.924l-2.642 4.513-.242 3.964-11.726-6.673 3.354-2.183 2.643-4.512c1.383-2.362 4.439-3.132 6.794-1.792 2.35 1.339 3.2 4.324 1.819 6.683z"
          clipRule="evenodd"
        ></path>
        <path
          fillRule="evenodd"
          d="M20.159 31.614l.965.56.895-1.529-.964-.561-.896 1.53zM22.56 24.098c.687.802.848 1.968.275 2.947l-1.509 2.575.964.561 1.503-2.565c.89-1.522.553-3.38-.655-4.53l-.578 1.012z"
          clipRule="evenodd"
        ></path>
        <path d="M11.854 18.5l-.952-.425a9.268 9.268 0 012.349-3.24 9.772 9.772 0 013.269-1.9c1.17-.41 2.416-.62 3.702-.624 1.252-.006 2.497.19 3.688.58l-.324.998c-4.11-1.356-9.62-.2-11.732 4.61z"></path>
        <path d="M14.397 18.893l-.951-.425a6.024 6.024 0 011.526-2.105 6.336 6.336 0 012.12-1.233 7.278 7.278 0 012.391-.403h.025c.8-.002 1.595.125 2.355.375l-.323.997c-2.505-.826-5.86-.128-7.143 2.794z"></path>
      </g>
      <defs>
        <clipPath id="clip0_397_1161">
          <path
            fill="#fff"
            d="M0 0H19.346V26.38H0z"
            transform="translate(7.914 12.31)"
          ></path>
        </clipPath>
      </defs>
    </Svg>
  );
}

export default Icon;
